export default __webpack_public_path__ + "static/media/three-dots-vertical.ea85c632.svg";